// extracted by mini-css-extract-plugin
module.exports = {"businessDetails":"styles_businessDetails__3uLp1","tabs":"styles_tabs__2Sn4I","tab":"styles_tab__e_lY0","tabPanel":"styles_tabPanel__nCVz0"};